import mixpanelSvc from '@efex-services/mixpanel/mixpanelSvc';
import { useState } from 'react';
import { StepsControl } from '../constants';
import FormCard from './components/FormCard';
import { useFormData } from './context';
import CompanyInformation from './steps/CompanyInformation';
import PersonalInformation from './steps/PersonalInformation';
import TermsAndConditions from './steps/TermsAndConditions';
import WelcomePage from './steps/WelcomePage';

interface IRegisterForm {
  createUser: (values: any) => void;
  error?: string;
  errorCode?: string;
  loading: boolean;
  isSubAccount?: boolean;
}

const RegisterForm = ({
  createUser,
  error,
  errorCode,
  loading,
  isSubAccount = false,
}: IRegisterForm) => {
  const [formStep, setFormStep] = useState(StepsControl.WelcomePage);
  const { data } = useFormData();

  const nextFormStep = () => setFormStep((currentStep) => currentStep + 1);

  const prevFormStep = () => setFormStep((currentStep) => currentStep - 1);

  const createUserFromData = () => {
    const { confirmPassword, ...rest } = data;
    createUser(rest);
    mixpanelSvc.track('Register successfully');
  };

  return (
    <FormCard currentStep={formStep} activeStep={formStep - 1}>
      <>
        {formStep === StepsControl.WelcomePage && (
          <WelcomePage nextFormStep={nextFormStep} />
        )}
        {formStep === StepsControl.GeneralInformation && (
          <PersonalInformation
            formStep={formStep}
            error={error}
            errorCode={errorCode}
            nextFormStep={nextFormStep}
            isSubAccountEnabled={isSubAccount}
          />
        )}
        {formStep === StepsControl.CompanyInformation && (
          <CompanyInformation
            formStep={formStep}
            error={error}
            errorCode={errorCode}
            nextFormStep={nextFormStep}
            prevStep={prevFormStep}
            isSubAccountEnabled={isSubAccount}
          />
        )}

        {formStep === StepsControl.TermsInformation && (
          <TermsAndConditions
            formStep={formStep}
            loading={loading}
            error={error}
            errorCode={errorCode}
            nextFormStep={createUserFromData}
            prevStep={prevFormStep}
          />
        )}
      </>
    </FormCard>
  );
};

export default RegisterForm;
